import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getConstantByValue from "../constant/getConstantByValue"
import getNumberOfLayers from "../getNumberOfLayers"

const resolveAdhesiveSideName = (value: string, { layer }: Pick<EstimateValues, "layer">) => {
  const numberOfLayers = getNumberOfLayers({ layer })
  const isOneLayer = numberOfLayers === 1

  switch (value) {
    case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(片面)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(2層)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(3層)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面と同じ面(L1面)(4層)"].value:
      return isOneLayer ? "パターン面と同じ面" : "L1面"
    case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(片面)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(2層)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(3層)"].value:
    case ESTIMATE_CONSTANT.接着面["パターン面とは逆の面(Ln面)(4層)"].value:
      return isOneLayer ? "パターン面とは逆の面" : `L${numberOfLayers}面`
    default:
      return getConstantByValue("rfContactPortionBonding1", value).name
  }
}

export default resolveAdhesiveSideName
